const translation = {
  api_key: {
    title: 'API KEY管理',
    alert: {
      line1:
        '• API Key 是您请求大模型服务的重要凭证。API Key 长期有效，请您不要将密钥信息共享至公开环境,妥善保管并定期轮换密钥，避免因未经授权的使用造成安全风险或资金损失。',
      line2:
        '• 为保障账户安全，我们会自动更换检测到的泄漏密钥。API Key 只能禁用，无法删除。',
    },
    actions: {
      add: '增加 API Key',
      enable: '启用',
      disable: '禁用',
      rename: '修改名称',
      copy_success: 'API Key 已复制到剪贴板',
      copy_failed: '复制失败，请手动复制',
      create_success: 'API Key 创建成功',
      create_failed: '创建 API Key 失败，请重试',
      rename_success: '名称修改成功',
      rename_failed: '修改名称失败，请重试',
      status_success: '状态已更新',
      status_failed: '状态更新失败，请重试',
      fetch_key_failed: '获取 API Key 失败',
    },
    filters: {
      all: '全部',
      mine: '我创建的',
    },
    columns: {
      name_id: '名称 / ID',
      api_key: 'API Key',
      status: '状态',
      created_at: '创建时间',
      last_used_at: '最后使用时间',
      creator: '创建人',
      operation: '操作',
      status_values: {
        active: '生效中',
        disabled: '已禁用',
      },
    },
    tooltip: {
      last_used_at:
        '该 API Key 最近一次被用于接口鉴权的时间，该数据可能有分钟级别的延迟（每5分钟更新一次）',
    },
    empty: '暂无 API Key 数据',
    pagination_total: '共 {{total}} 条',
    confirm: '确定',
    cancel: '取消',
    dialogs: {
      add_title: '增加 API Key',
      rename_title: '修改名称',
      disable_confirm_title: '您确定要禁用 API Key 吗？',
      disable_confirm_content: '名称：{{name}}',
    },
    form: {
      name: 'API 名称',
      name_placeholder: '请输入 API 名称',
      validation: {
        name_required: '请输入 API 名称',
        name_too_long: '上限 20 字符',
        name_pattern: '必须以中英文开头，可包含数字和符号 -_',
      },
    },
  },
  models: {
    title: '模型广场',
    search_placeholder: '请输入模型名称',
    filter: {
      title: '筛选模型',
      clear: '清空',
      confirm: '搜索',
      scenarios: '任务场景',
      model_size: '模型大小',
      context_length: '上下文长度',
      provider: '支持的芯片',
      model_provider: '模型提供商',
    },
    pagination: {
      total: '第 {{start}}-{{end}} 条，共 {{total}} 条',
    },
    actions: {
      view_detail: '查看详情',
      api_reference: 'API参考',
      try_now: '立即体验',
    },
    status: {
      offline: '已下线',
    },
  },
  model_detail: {
    title: '模型详情',
    tabs: {
      details: '模型详情',
      usage: '调用说明',
      api_docs: 'API文档',
    },
    sections: {
      introduction: '模型介绍',
      tags: '模型标签',
      api_docs: 'API文档',
      related_docs: '相关文档',
      api_key: 'API 密钥',
      call_example: '调用示例',
    },
    actions: {
      view_api_docs: '查看API文档',
      view_related_docs: '查看相关文档',
      get_api_key: '获取密钥',
      try_now: '立即体验',
      view: '点击查看',
    },
    tips: {
      api_key: '创建 API Key 或复制已有密钥。',
    },
    example: {
      shell_curl: 'Shell / cURL',
      python: 'Python',
      nodejs: 'Node.js',
      sample_question: '你是谁',
    },
    fields: {
      model_name: '模型名称',
      provider: '提供商',
      context_length: '上下文长度',
      max_generate_length: '最大生成长度',
      created_at: '创建时间',
      statistics: '用量统计',
      price_input: '推理输入价格',
      price_output: '推理输出价格',
    },
    empty: {
      introduction: '暂无模型介绍',
      api_docs: '暂无API文档',
    },
    not_found: '未找到模型',
    not_found_desc: '请求的模型不存在或已被删除',
    messages: {
      copy_code_success: '代码已复制到剪贴板',
      copy_name_success: '模型名称已复制到剪贴板',
      copy_failed: '复制失败',
    },
    errors: {
      fetch_failed: '获取模型详情失败',
      fetch_failed_retry: '获取模型详情失败，请稍后重试',
    },
    status: {
      online: '在线',
      offline: '离线',
    },
    common: {
      error: '错误',
      unknown: '未知',
    },
    price: {
      yuan_per_million_tokens: '¥{{price}} 元 / 百万 token',
      free: '免费',
    },
  },
  model_service_prices: {
    title: '模型服务价格',
    price_list: '服务价目表',
    tip: '此价目标仅面向使用API调用服务的用户，客户端体验用户不做收费。',
    columns: {
      model_name: '模型名称',
      model_type: '模型类型',
      provider: '供应方',
      input_price: '推理输入',
      output_price: '推理输出',
      action: '操作',
      usage_statistics: '用量统计',
      view_detail: '查看详情',
    },
    default_model_type: '大语言模型',
    free_quota: '免费额度',
    yuan_per_million_tokens: '元/百万 tokens',
    pagination_total: '共 {{total}} 条',
    errors: {
      fetch_price_failed: '获取价格失败',
      fetch_models_failed: '获取模型列表失败',
    },
  },
  trial: {
    title: '体验中心',
    model_selection: '模型选择',
    select_model_placeholder: '选择大语言模型',
    interaction_config: '交互配置',
    stream: 'Stream',
    stream_tooltip: '是否使用流式返回输出模型生成结果。',
    stream_enabled: '开启',
    stream_disabled: '关闭',
    system_prompt: 'System Prompt',
    system_prompt_tooltip: '系统不保存自定义prompt，若您输入的内容过长，可能会被截断。',
    system_prompt_placeholder: '系统不保存自定义prompt，若您输入的内容过长，可能会被截断',
    system_prompt_edit: 'System Prompt 编辑',
    context_length: '上下文长度',
    context_length_tooltip: '模型在一次处理中能够接收和理解的最大文本量，包括输入的提示（prompt）以及模型生成的回复，以"token"为单位来衡量。',
    max_tokens: 'Max_tokens',
    max_tokens_tooltip: '模型输出的最大token数量。',
    temperature: 'Temperature',
    temperature_tooltip: '采样温度，控制输出的随机性。值越高，会使输出更加随机，更具创造性；值越低，会使输出更加集中和确定性。我们推荐您根据应用场景调整 top_p 或 temperature 参数，但不建议同时调整两个参数。',
    top_p: 'Top_p',
    top_p_tooltip: '用于控制输出文本的随机性和多样性，取值越大，生成文本越丰富。我们推荐您根据应用场景调整 top_p 或 temperature 参数，但不建议同时调整两个参数。',
    clear_messages: '清除消息',
    confirm: '确定',
    cancel: '取消',
    errors: {
      restore_system_prompt_failed: '恢复 System Prompt 失败',
      save_system_prompt_failed: '保存 System Prompt 失败',
      request_failed: '请求失败',
      cannot_read_response_stream: '无法读取响应流',
      unknown_error: '未知错误',
      messages_cleared: '消息已清除',
      clear_messages_failed: '清除消息失败',
      select_model_first: '请先选择一个模型',
      model_call_failed: '调用模型失败: {{error}}',
      model_response_format_error: '模型返回格式异常',
      model_call_failed_retry: '调用模型失败，请稍后重试',
    },
    placeholder: {
      input_instruction: '请向我发出指令，我可以完成对话聊天，智能问答，代码生成等多种任务...',
    },
    empty_state: {
      welcome: '欢迎体验',
      model: '模型',
      description1: '您可在下方输入问题或点击推荐示例免费体验模型能力',
      description2: '请注意，模型可能无法回答不合适的问题',
      ai_assistant: 'AI 助手',
    },
  },
  statistics: {
    load_api_keys_failed: '加载API Key列表失败',
    fetch_statistics_failed: '获取统计数据失败，请重试',
    select_user_account: '请选择用户账号',
    filter_tip: '此处将按照执行完成时间进行周期筛选。由于数据量较大，查询超过30天的用量数据可能需要5-10秒等待时间。',
    time_range_limit: '查询时间范围已限制为最近3个月的数据。',
    api_only_tip: '当前仅统计通过API调用产生的用量数据。',
  },
}

export default translation
